<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 14:20:31
 * @Description: file content
 -->
<template>
  <div class="mymodal" v-show="value">
    <div class="msgbox" :class="{ big : message.prizeInfo && message.prizeInfo.prizeName != '至多200元话费'}">
      <!-- <div class="title">中奖啦</div> -->
      <div class="content">
        <div class="tip1" v-if="message.prizeInfo && message.prizeInfo.prizeName === '至多200元话费'">恭喜您中奖</div>
        <div class="tip1" v-if="message.prizeInfo && message.prizeInfo.prizeName === '至多200元话费'">至多两百元话费</div>
        <template v-else>
          <div class="tip2">恭喜您已抽中{{message.prizeInfo && message.prizeInfo.prizeName}}，请正确填写信息获取兑换码！</div>
          <div class="tip2">可进入【我的奖品】查看</div>
          <div class="tip2">或注意短信通知</div>
        </template>
        <div class="input_txt" v-if="message.prizeInfo && message.prizeInfo.prizeName != '至多200元话费'">
          <div class="phoneNum">姓名</div>
          <div>
            <input @blur="blurInput" v-model="name" type="text" placeholder />
          </div>
        </div>
        <div class="input_txt">
          <div class="phoneNum">电话</div>
          <div>
            <input @blur="blurInput" v-model="mobile" type="tel" placeholder />
          </div>
        </div>
        <div class="input_code">
          <div class="left">
            <input @blur="blurInput" v-model="vcode" type="number" placeholder oninput="if(value.length>6)value=value.slice(0,6)" />
          </div>
          <div class="right">
            <div @click="getVcode" v-if="!showVcode">{{getVcodes}}</div>
            <div v-else>{{counts}}s</div>
          </div>
        </div>
        <div class="input_txt"  v-if="message.prizeInfo && message.prizeInfo.prizeName != '至多200元话费'">
          <Multiselect
            v-model="userAdress"
            :options="addrList"
            placeholder="请下拉选择领奖地址"
            :searchable="false"
            @input="selectAddr"
            :allow-empty="false"
            :show-labels="false"
            track-by="name"
            label="name"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </Multiselect>
        </div>
      </div>
      <div class="btns">
        <div class="my_btn" @click="submit">
          <img
            src="https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/floppy-bird/submit_get.png"
            alt
          />
        </div>
      </div>
      <img
        class="close"
        @click="clickClose"
        src="https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/floppy-bird/close_news.png"
        alt
      />
    </div>
  </div>
</template>

<script>
import { MessageBox, Toast, Indicator } from "mint-ui";
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  props: {},
  data() {
    return {
      value: false,
      title: "",
      message: "",
      callback: null,
      userInfo: this.$userInfo,
      vcode: "",
      name: "",
      mobile: "",
       //选则领奖地址
      userAdress: [],
      addressId: "",
      addressName: '',
      addrList: [],
      addressList: [],
      counts: "",
      timers: null,
      getVcodes: "验证码",
      showVcode: false,
      prizeId: 0,
    };
  },
  watch: {
    value: function(newVal) {
      if (newVal) {
        this.message.prizeInfo && this.message.prizeInfo.id && this.getPrizeById(this.message.prizeInfo.id)
        this.showVcode = false;
        clearInterval(this.timers);
        this.timers = null;
        this.vcode = "";
      }
    }
  },
  computed: {},
  methods: {
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    // 获取对应奖品的地址
    async getPrizeById(prizeId) {
      const data = await this.$httpdf.get(this.apiHost + 'home/prize/getPrizeById', { prizeId: prizeId })
      if (data.code == 0) {
        if (data.data.address) {
          this.addrList = [];
          // debugger
          data.data.address.forEach((v, i) => {
            let obj = {};
            obj.addressId = v.addressId;
            obj.addressName = v.addressName;
            obj.name = v.addressName;
            obj.id = i;
            this.addrList.push(obj);
          });
        }
      } else {
        MessageBox.alert(data.msg);
      }
    },
    selectAddr: function (data) {
      this.userAdress = data;
      console.log(this.userAdress);
      this.addressName = data.addressName;
      this.addressId = data.addressId;
    },
    //获取验证码
    getVcode() {
      const _self = this;
      const TIME_COUNT = 60;
      if (!this.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        //获取验证码
        let url = this.apiHost + `common/smsCode`;
        let data = new FormData();
        data.append("mobile", this.mobile);
        this.$httpdf
          .post(
            url,
            data
          )
          .then((data) => {
            if (data.code == 0) {
              Toast({
                message: "验证码已发送至您的手机",
                duration: 2000,
              });
              if (!_self.timers && _self.mobile) {
                _self.counts = TIME_COUNT;
                _self.showVcode = true;
                _self.timers = setInterval(() => {
                  if (_self.counts > 0 && _self.counts <= TIME_COUNT) {
                    _self.counts--;
                  } else {
                    _self.showVcode = false;
                    clearInterval(_self.timers);
                    _self.timers = null;
                  }
                }, 1000);
              }
            } else {
              MessageBox.alert(data.msg);
            }
          });
      }
    },
    //提交手机号
    async submit() {
      let _self = this;
      if (!_self.name) {
        return MessageBox.alert("请输入姓名", "提示");
      } else if (!_self.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        if (!this.$util.isMobile(_self.mobile)) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!_self.vcode) {
        return MessageBox.alert("请输入验证码", "提示");
      }
      if (_self.message.prizeInfo.prizeName !== "至多200元话费") {
        if (!_self.addressId) {
          return MessageBox.alert("请选择兑奖地址", "提示");
        }
      }
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      
      if (_self.message.prizeInfo.prizeName !== "至多200元话费") {
         const data = await this.$httpdf.get(this.apiHost + 'home/prize/receive',
         {
           addressId: this.addressId,
           addressName: this.addressName,
           code: this.vcode,
           mobile: this.mobile,
           name: this.name,
           prizeId: this.message.prizeInfo.id
         })
        if (data.code == 0) {
          Indicator.close();
          Toast({
            message: "领取成功",
            duration: 2000,
          });
          this.value = false;
          this.callback("cancel")
        } else {
          Indicator.close();
          MessageBox.alert(data.msg);
        }
      } else {
        let url = this.apiHost + `home/prize/sendTelFare?mobile=${_self.mobile}&verCode=${_self.vcode}&prizeId=${_self.message.prizeInfo.id}`;
        const data = await this.$httpdf.post(url)
        if (data.code == 0) {
          Indicator.close();
          Toast({
            message: "领取成功",
            duration: 2000,
          });
          this.value = false;
          this.callback("cancel")
        } else {
          Indicator.close();
          MessageBox.alert(data.msg);
        }
      }
    },
    clickClose() {
      if (this.message.prizeInfo.id && !this.message.prizeInfo.isMyprize) {
        MessageBox({
          title: '提示',
          message: '现在退出弹窗，该奖品将在首页【我的奖品】中保留2分钟领取时间，超时不领取奖品将会释放给其他用户哦～请您慎重考虑！',
          showCancelButton: true
        }).then((action) => {
          if (action === 'confirm') {
            this.value = false;
            this.callback("cancel")
          }
        })
      } else {
        this.value = false;
        this.callback("cancel")
      }
    }
  },
  created() {
  },
  mounted() {
    if (this.$userInfo) {
      this.name = this.$userInfo.nickName;
    }
    
  }
};
</script>
<style lang="scss" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.msgbox {
  background-image: url('https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/floppy-bird/prize_bg1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  width: 310px;
  height: 408px;
  &.big {
    width: 309px;
    height: 521px;
    background: url( $imgHost + 'bird/bird_form_bg.png?t=3') center 0 / 100% no-repeat;
    .btns {
      padding-top: 10px;
    }
  }
}

.msgbox .title {
  font-size: 16px;
  font-family: PingFang SC;
  color: #ffffff;
  background-color: #e82f1c;
  min-height: 45px;
  line-height: 45px;
  text-align: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.msgbox .content {
  width: 90%;
  margin: 0 auto;
  padding-top: 85px;
  text-align: center;
}

.msgbox .content .tip1 {
  padding-top: 5px;
  font-size: 26px;
  font-family: FZHZGBJW;
  font-weight: normal;
  color: rgba(231, 66, 145, 1);
  line-height: 34px;
  font-weight: bold;
}

.msgbox .content .tip2 {
  font-size: 20px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #E74291;
  line-height: 30px;
}

.msgbox .content input {
  border-radius: 3px;
  width: 200px;
  height: 37px;
  text-indent: 15px;
  background: rgba(252, 255, 215, 1);
  border: 1px solid rgba(231, 66, 145, 1);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000;
}

.msgbox .content .input_txt {
  width: 100%;
  // margin: 12px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
  box-sizing: border-box;

  .phoneNum {
    color: #E74291;
    font-size: 21px;
  }
}

.msgbox .content .input_code {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  box-sizing: border-box;

  .left {
    input {
      width: 180px;
    }
  }
}

.msgbox .content .input_code .left {
  width: 100px;
}

.msgbox .content .input_code .right >div {
  font-size: 21px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: rgba(231, 66, 145, 1);
  line-height: 22px;
}

.msgbox .my_btn {
  width: 147px;
  height: 54px;

  img {
    width: 100%;
    height: 100%;
  }
}

.msgbox .btns {
  display: flex;
  justify-content: center;
  padding-top: 43px;
}

.msgbox .close {
  position: absolute;
  top: -30px;
  right: -2px;
  width: 31px;
  height: 31px;
  z-index: 2000;
}

.address_detail {
  line-height: 20px;
  font-size: 12px;
  font-family: PingFang SC;
  color: rgba(51, 51, 51, 1);
  text-align: justify;
}

.input_txt {
  ::v-deep .multiselect__tags {
    height: 36px !important;
    line-height: 36px !important;
    min-height: 36px !important;
    border: 0;
    padding-top: 0;
    padding-left: 10px;
    border-radius: 3px;
    background: rgba(252, 255, 215, 1);
    border: 1px solid rgba(231, 66, 145, 1);
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000;
    .multiselect__input, .multiselect__single{
      background-color: transparent;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0;
      margin: 0;
      line-height: 36px !important;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #000;
    }
    .multiselect__placeholder {
      line-height: 36px !important;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      padding: 0;
      color: #000;
    }
  }
  ::v-deep .multiselect__select {
    &::before {
      color: #E74291;
    }
  }
}
</style>